let list = [
  {
    "val": "GradenGoldenrod",
    "name": "霓虹灯金黄",
    "thumbnailUrl": "/static/img/gradenGoldenrod.jpg",
    "gifUrl": "/static/img/gradenGoldenrod.gif",
    "color": "#FFFF00",
    "dynamic": true
  },
  {
    "val": "FlatSimple",
    "name": "扁平式阴影",
    "thumbnailUrl": "/static/img/flatSimple.png",
    "color": "#F1EBE5"
  },
  {
    "val": "DropCenter",
    "name": "阴影",
    "thumbnailUrl": "/static/img/dropCenter.png",
    "color": "#FFFFFF"
  },
  {
    "val": "PopUp",
    "name": "上阴影",
    "thumbnailUrl": "/static/img/popUp.png",
    "color": "#FFFFFF"
  },
  {
    "val": "PopLeft",
    "name": "左阴影",
    "thumbnailUrl": "/static/img/popLeft.png",
    "color": "#FFFFFF"
  },
  {
    "val": "PopRight",
    "name": "右阴影",
    "thumbnailUrl": "/static/img/popRight.png",
    "color": "#FFFFFF"
  },
  {
    "val": "ThreeD",
    "name": "立体",
    "thumbnailUrl": "/static/img/threeD.png",
    "isVip": 1,
    "payType": 4,
    "color": "#FFFFFF"
  },
  {
    "val": "Inset",
    "name": "浮雕",
    "thumbnailUrl": "/static/img/inset.png",
    "isVip": 1,
    "payType": 4,
    "color": "#666666"
  },
  {
    "val": "Glitch",
    "name": "抖音风1",
    "thumbnailUrl": "/static/img/glitch.png",
    "gifUrl": "/static/img/glitch.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#000000",
    "dynamic": true
  },
  {
    "val": "GlitchRed",
    "name": "抖音风2",
    "thumbnailUrl": "/static/img/glitchRed.png",
    "gifUrl": "/static/img/glitchRed.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#000000",
    "dynamic": true
  },
  {
    "val": "GradenPink",
    "name": "霓虹灯浅粉",
    "thumbnailUrl": "/static/img/gradenPink.jpg",
    "gifUrl": "/static/img/gradenPink.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#FFB6C1",
    "dynamic": true
  },
  {
    "val": "GradenAzure",
    "name": "霓虹灯天蓝",
    "thumbnailUrl": "/static/img/gradenAzure.jpg",
    "gifUrl": "/static/img/gradenAzure.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#F0FFFF",
    "dynamic": true
  },
  {
    "val": "GradenTomato",
    "name": "霓虹灯茄红",
    "thumbnailUrl": "/static/img/gradenTomato.jpg",
    "gifUrl": "/static/img/gradenTomato.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#FF6347",
    "dynamic": true
  },
  {
    "val": "GradenYellow",
    "name": "霓虹灯黄绿",
    "thumbnailUrl": "/static/img/gradenLightyellow.jpg",
    "gifUrl": "/static/img/gradenLightyellow.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#FFFF00",
    "dynamic": true
  },
  {
    "val": "GradenLightyellow",
    "name": "霓虹灯浅黄",
    "thumbnailUrl": "/static/img/gradenYellow.jpg",
    "gifUrl": "/static/img/gradenYellow.gif",
    "isVip": 1,
    "payType": 4,
    "color": "#FFFFE0",
    "dynamic": true
  }
]

export default function getText (key) {
  let item = list.find(v => v.val === key) || {};
  return item.name;
}



// WEBPACK FOOTER //
// ./src/components/topnav/riskDrop/artwords.js